import { RootState } from '../store'

export const selectActeurAction = (state: RootState) =>
  state.acteurAction.acteurAction
export const selectActeurActionLoading = (state: RootState) =>
  state.acteurAction.loading
export const selectActeurActionError = (state: RootState) =>
  state.acteurAction.error
export const selectActions = (state: RootState) => state.acteurAction.actions
export const selectActeurs = (state: RootState) => state.acteurAction.acteurs
